module.exports = __webpack_public_path__ + "static/media/ic_lock.f053c93b.svg";